// Queue for processing async tasks sequentially
export class AsyncQueue {
    constructor() {
        Object.defineProperty(this, "queue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "isProcessing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.isProcessing = false;
    }
    // Add task to the queue
    enqueue(task) {
        return new Promise((resolve, reject) => {
            this.queue.push(() => task().then(result => {
                resolve(result);
                // Explicitly return a value of type T, satisfying the compiler's type checking.
                return result;
            }).catch(error => {
                reject(error);
                // Explicitly return a value of type T, satisfying the compiler's type checking.
                return error;
            }));
            // Start processing the queue if not already doing so
            if (!this.isProcessing) {
                this.processQueue();
            }
        });
    }
    // Process tasks in the queue
    async processQueue() {
        if (this.queue.length === 0) {
            this.isProcessing = false;
            return;
        }
        this.isProcessing = true;
        const nextTask = this.queue.shift();
        if (nextTask) {
            await nextTask();
            this.processQueue();
        }
    }
}
//# sourceMappingURL=AsyncQueue.js.map